import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number = 80): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' + value.substring(value.length - 5,value.length) : value;
  }

}
